import * as tslib_1 from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import { URLS } from '@wix/da-url/dist/src/constants';
import ErrorBoundary from '../../ErrorBoundary';
import Logo from '../../Logo';
import ScrollAware from '../../ScrollAware';
import SearchButton from './SearchButton';
import CartIcon from '../../Icons/Cart';
import { IconSize } from '../../Icons/IconWrap';
import BurgerMenu from './BurgerMenu';
import UserMenu from './UserMenu';
import Sticky from '../../Sticky';
import { BiEventType, BiLink } from '../../biLogger';
import SearchPopup from '../_partials/SearchPopup/SearchPopup';
import { HeaderBehavior } from '../../types/headerBehavior';
import s from './SiteHeaderMobile.scss';
var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["UP"] = 0] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 1] = "DOWN";
})(ScrollDirection || (ScrollDirection = {}));
var defaultProps = {
    scrollTop: 0,
    mobileBehavior: HeaderBehavior.STICKY,
};
var SiteHeaderMobile = /** @class */ (function (_super) {
    tslib_1.__extends(SiteHeaderMobile, _super);
    function SiteHeaderMobile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            scrollTop: defaultProps.scrollTop,
            isSearchPopupShown: false,
            isInitialRender: true,
            scrollDirection: ScrollDirection.UP,
        };
        _this.searchPopupRef = React.createRef();
        _this.handleSearchButtonClick = function () {
            if (_this.state.isSearchPopupShown) {
                return _this.setState({ isSearchPopupShown: false });
            }
            var isSearchPopupShown = _this.state.isSearchPopupShown;
            if (!isSearchPopupShown) {
                _this.setState({
                    isSearchPopupShown: true,
                });
            }
            if (_this.searchPopupRef &&
                _this.searchPopupRef.current &&
                _this.searchPopupRef.current.focus) {
                _this.searchPopupRef.current.focus();
            }
        };
        _this.openOrFocusSearchPopup = function () {
            var isSearchPopupShown = _this.state.isSearchPopupShown;
            if (!isSearchPopupShown) {
                _this.setState({
                    isSearchPopupShown: true,
                });
            }
            _this.props.onSiteHeaderSearchButtonClicked();
        };
        _this.closeSearchPopup = function () {
            _this.setState({
                isSearchPopupShown: false,
            });
        };
        return _this;
    }
    SiteHeaderMobile.getDerivedStateFromProps = function (nextProps, prevState) {
        var scrollTop = nextProps.scrollTop;
        SiteHeaderMobile.isInitialRender =
            SiteHeaderMobile.isInitialRender && scrollTop === 0;
        var scrollDirection = nextProps.scrollTop > prevState.scrollTop
            ? ScrollDirection.DOWN
            : scrollTop < prevState.scrollTop
                ? ScrollDirection.UP
                : prevState.scrollDirection;
        var isInitialRender = SiteHeaderMobile.isInitialRender;
        return { scrollTop: scrollTop, scrollDirection: scrollDirection, isInitialRender: isInitialRender };
    };
    // What's going on here: on mobile we need a special behaviour for the header,
    // so we have different behaviors.
    SiteHeaderMobile.prototype.render = function () {
        switch (this.props.mobileBehavior) {
            case HeaderBehavior.INLINE:
                return this.renderInlineHeader();
            case HeaderBehavior.STICKY_BURGER:
                return this.renderInlineWithStickyBurgerHeader();
            case HeaderBehavior.STICKY:
                return this.renderStickyHeader();
            case HeaderBehavior.UNOBTRUSIVE:
                // It is shown on page load, then after 0.8s second it slides up, and hides out of view
                // When you scroll to the top after initial page load it slides down
                // but as soon as you scroll down, it hides again
                return this.renderUnobtrusiveHeader();
            default:
                return null;
        }
    };
    SiteHeaderMobile.prototype.renderInlineHeader = function () {
        return (React.createElement("header", { className: classnames(s['root'], this.props.className) },
            React.createElement(ErrorBoundary, null,
                this.renderHeaderPartial(),
                this.renderBurgerButton())));
    };
    SiteHeaderMobile.prototype.renderInlineWithStickyBurgerHeader = function () {
        var _this = this;
        return (React.createElement("header", { className: classnames(s['root'], this.props.className) },
            React.createElement(ErrorBoundary, null,
                this.renderHeaderPartial(),
                React.createElement(Sticky, { zIndex: +s['zIndex'], className: s['sticky-burger'] }, function (isStuck) { return _this.renderBurgerButton(); }))));
    };
    SiteHeaderMobile.prototype.renderStickyHeader = function () {
        return (React.createElement(ErrorBoundary, { className: classnames(s['root'], this.props.className) },
            React.createElement("header", { className: classnames(s['root'], this.props.className, s['sticky-header']) },
                this.renderHeaderPartial(),
                this.renderBurgerButton())));
    };
    SiteHeaderMobile.prototype.renderUnobtrusiveHeader = function () {
        var _a = this.state, scrollTop = _a.scrollTop, scrollDirection = _a.scrollDirection, isInitialRender = _a.isInitialRender;
        var hideHeader = isInitialRender || scrollTop > 0;
        var showHeader = !isInitialRender &&
            (scrollTop === 0 || scrollDirection !== ScrollDirection.DOWN);
        return (React.createElement("header", { className: classnames(s['root'], this.props.className, s['unobtrusive-header'], showHeader && s['show-header'], hideHeader && s['hide-header']) },
            React.createElement(ErrorBoundary, null,
                this.renderHeaderPartial(),
                this.renderBurgerButton())));
    };
    SiteHeaderMobile.prototype.renderHeaderPartial = function () {
        var environment = this.props.environment;
        return (React.createElement("div", { className: s['header'] },
            React.createElement("div", { className: s['left'] }, this.renderCartButton()),
            React.createElement("div", { className: s['middle'] },
                React.createElement(BiLink, { biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_name: 'logo',
                        link_url: URLS.ROOT,
                    }, href: URLS.ROOT, className: s['logo-link'] },
                    React.createElement(Logo, { textColor: "white", size: "small" }),
                    ['rc', 'dev'].includes(String(environment)) && (React.createElement("div", { className: s['env'] }, String(environment).toUpperCase())))),
            React.createElement("div", { className: s['right'] },
                React.createElement(SearchButton, { className: s['icon-button'], iconClassName: s['search-icon'], onClick: this.handleSearchButtonClick }),
                this.renderSearchPopup(),
                React.createElement(UserMenu, tslib_1.__assign({}, this.props)))));
    };
    SiteHeaderMobile.prototype.renderBurgerButton = function () {
        return (React.createElement("div", { className: classnames(s['burger-button']) },
            React.createElement(BurgerMenu, { activeMainMenuItem: this.props.activeMainMenuItem, onOpenMobileSearch: this.handleSearchButtonClick, redirectOnSubmit: this.props.isLegacyHeader })));
    };
    SiteHeaderMobile.prototype.renderCartButton = function () {
        var cartCount = this.props.cartCount;
        return cartCount ? (React.createElement(BiLink, { biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'cart',
                link_url: URLS.CART,
                indicator: cartCount,
            }, href: URLS.CART, className: s['icon-button'] },
            React.createElement(CartIcon, { className: s['cart-icon'], size: IconSize.MEDIUM, withPadding: true }),
            React.createElement("span", { className: s['number-label__green'] },
                React.createElement("span", { className: s['number'] }, cartCount > 99 ? '99+' : cartCount)))) : null;
    };
    SiteHeaderMobile.prototype.renderSearchPopup = function () {
        var isSearchPopupShown = this.state.isSearchPopupShown;
        if (!isSearchPopupShown) {
            return null;
        }
        return (React.createElement(SearchPopup, { onClose: this.closeSearchPopup, isMobile: true, ref: this.searchPopupRef }));
    };
    SiteHeaderMobile.defaultProps = defaultProps;
    SiteHeaderMobile.isInitialRender = true;
    return SiteHeaderMobile;
}(React.PureComponent));
export { SiteHeaderMobile };
var ScrollAwareSiteHeaderMobile = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollAwareSiteHeaderMobile, _super);
    function ScrollAwareSiteHeaderMobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollAwareSiteHeaderMobile.prototype.render = function () {
        var _this = this;
        return (React.createElement(ScrollAware, null, function (_a) {
            var scrollTop = _a.scrollTop;
            return React.createElement(SiteHeaderMobile, tslib_1.__assign({ scrollTop: scrollTop }, _this.props));
        }));
    };
    return ScrollAwareSiteHeaderMobile;
}(React.Component));
export { ScrollAwareSiteHeaderMobile };
export default withTranslation()(SiteHeaderMobile);
//# sourceMappingURL=SiteHeaderMobile.js.map